module.exports = __webpack_public_path__ + "static/media/icon-external-link-light.7fb2ff26.svg";